import EA from 'helpers/init';

export default EA.Methods.customCookiebot = () => {
    setTimeout(() => {
        const container = document.getElementById('cookiePrivacy');
        if (!container) return; // safety check

        const script = document.createElement('script');
        script.id = 'CookieDeclaration';
        script.src = 'https://consent.cookiebot.com/8aeb0a5a-2ad7-4977-8116-2f2c3d6bf810/cd.js';
        script.type = 'text/javascript';
        script.async = true;

        container.appendChild(script);
    }, 10);
};